"use client";

import type { AboutData } from "@/services/public.service";
import Image from "next/image";

export default function AboutGallery({ about, isAr }: { about: AboutData; isAr: boolean }) {
  const t = (a: string, e: string) => (isAr ? a : e);
  const gallery = about.gallery || [];
  if (gallery.length === 0) return null;

  return (
    <section className="bg-clay-50 najdi-pattern py-16 md:py-20">
      <div className="container mx-auto px-6">
        <h2 className="font-display text-3xl md:text-4xl font-bold text-ink-900 text-center mb-12">
          {t("جولة داخل وحداتنا", "A tour inside our units")}
        </h2>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {gallery.map((img, i) => (
            <div
              key={i}
              className={`relative aspect-[4/3] overflow-hidden rounded-2xl bg-clay-100 ${
                i % 5 === 0 ? "col-span-2 md:row-span-2" : ""
              }`}
            >
              <Image src={img} alt={`${t("معرض", "Gallery")} ${i + 1}`} fill unoptimized className="object-cover hover:scale-105 transition-transform duration-500" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
